import { Link } from 'react-router-dom'

const ServicesSection = ({ college }) => {
  const boxes =
    college?.links_Services !== null
      ? college?.links_Services?.items?.map(item => {
          item = item?.content?.properties
          return {
            title: item?.title,
            description: item?.description,
            link: item?.url !== null ? item?.url[0]?.url : null
          }
        })
      : []

  return (
    <div className='flex flex-col gap-5 p-4 md:px-10'>
      <div className='grid grid-cols-[repeat(auto-fill,_minmax(12rem,_1fr))]  w-full gap-5'>
        {boxes?.map((box, i) => (
          <Link
            to={box?.link || '#'}
            key={i}
            className='flex flex-col items-center text-center justify-center gap-5 h-full w-full p-4 border-2 border-gray-800 rounded shadow-sm hover:shadow-md transition-shadow duration-300'
          >
            <h2 className='font-semibold '>{box?.title}</h2>
            {box?.description && <p className='text-sm'>{box?.description}</p>}
          </Link>
        ))}
      </div>
    </div>
  )
}

export default ServicesSection
